import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

/** True when the shopper asked the system for less motion (or we cannot tell yet). */
export const prefersReducedMotion = () => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  try {
    return Boolean(window.matchMedia(QUERY)?.matches);
  } catch {
    return false;
  }
};

/**
 * Live `prefers-reduced-motion: reduce`. Motion classes are only added when
 * this is false; the CSS in `styles/motion.css` also switches every
 * animation off under the same media query, so both layers agree.
 */
const useReducedMotion = () => {
  const [reduced, setReduced] = useState(prefersReducedMotion);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    let mql;
    try {
      mql = window.matchMedia(QUERY);
    } catch {
      return undefined;
    }
    if (!mql) return undefined;
    const onChange = (event) => setReduced(Boolean(event.matches));
    setReduced(Boolean(mql.matches));
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }
    if (typeof mql.addListener === 'function') {
      mql.addListener(onChange);
      return () => mql.removeListener(onChange);
    }
    return undefined;
  }, []);

  return reduced;
};

export default useReducedMotion;
